// extracted by mini-css-extract-plugin
export default {"title":"PrimaryBusinessAddress_title__mVI13","description":"PrimaryBusinessAddress_description__LvACf"};